export default __webpack_public_path__ + "static/media/bg9.34653dae.jpg";